module.exports = __webpack_public_path__ + "img/detail-02_3.a61c7454.png";